import React from 'react';
import { NotificationProvider } from './Components/Context/NotificationContext';
import NotificationPopup from './Components/Common/NotificationPopup';
import { ToastContainer } from "react-toastify";

//import Scss
import './assets/scss/themes.scss';

//imoprt Route
import Route from './Routes';


function App() {
  return (
    <React.Fragment>
      <NotificationProvider>
        <Route />
        <NotificationPopup/>
      </NotificationProvider>
      <ToastContainer />
    </React.Fragment>
  );
}

export default App;
